import { render, staticRenderFns } from "./TabConnectionView.vue?vue&type=template&id=b83c21aa&scoped=true&lang=pug"
import script from "./TabConnectionView.vue?vue&type=script&lang=js"
export * from "./TabConnectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83c21aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83c21aa')) {
      api.createRecord('b83c21aa', component.options)
    } else {
      api.reload('b83c21aa', component.options)
    }
    module.hot.accept("./TabConnectionView.vue?vue&type=template&id=b83c21aa&scoped=true&lang=pug", function () {
      api.rerender('b83c21aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/datasource/TabConnectionView.vue"
export default component.exports